import { Component, Inject, inject, OnInit, PLATFORM_ID } from '@angular/core';

import { SliderInfoComponent } from '../../shared/components/slider-info/slider-info.component';
import { ExploraNuestroMenuComponent } from '../../shared/components/explora-nuestro-menu/explora-nuestro-menu.component';
import { UnetenosComponent } from '../../shared/components/unetenos/unetenos.component';
import { LoaderSubitoComponent } from '../../shared/components/loader-subito/loader-subito.component';
import { LoaderSubitoService } from '../../shared/components/loader-subito/service/loader-subito.service';
import { DownloadAppsComponent } from "../download-apps/download-apps.component";
import { ErrorMessageComponent } from "../../shared/components/error-message/error-message.component";
import { CategoriesEstablishmentComponent } from "../../shared/components/categories-establishment/categories-establishment.component";
import { CategoriesGralComponent } from "../../shared/components/categories-gral/categories-gral.component";
import { AuthService } from '../../core/service/auth.service';
import { PerfilTourService } from '../../core/service/driver-tour/perfil-tour.service';
import { ShowModalTerminosyCondiciones } from "../../shared/components/showModalTerminosyCondiciones/showModalTerminosyCondiciones";
import { ConfettiService } from '../../shared/confetti/confetti.component';
import { LocalStorageService } from '../../core/service/local-storage/local-storage.service';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-presentation',
  imports: [SliderInfoComponent, ExploraNuestroMenuComponent, UnetenosComponent, LoaderSubitoComponent, DownloadAppsComponent, ErrorMessageComponent, CategoriesEstablishmentComponent, CategoriesGralComponent, ShowModalTerminosyCondiciones],
  templateUrl: './presentation.component.html',
  styleUrl: './presentation.component.css',
  standalone: true
})
export class PresentationComponent implements OnInit {
  authService = inject(AuthService);
  perfilTourService = inject(PerfilTourService);
  confettiService = inject(ConfettiService);
  localStorageService = inject(LocalStorageService);
  constructor(private loaderService: LoaderSubitoService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {


  }

  ngOnInit(): void {
    // Mostrar el loader al iniciar el componente
    // this.loaderService.showLoader();

    // Ocultar el loader más rápido para no bloquear la UI
    // // Los componentes con @defer se cargarán independientemente
    // setTimeout(() => {
    //   this.loaderService.hideLoader();
    // }, 800); // Reducido a 0.8 segundos para mejor UX

    if (isPlatformBrowser(this.platformId)) {
      const firstVisit = this.localStorageService.getSessionItem<boolean>('firstVisit');
      if (!firstVisit) {
        this.confettiService.fireworksLottie();
        this.localStorageService.setSessionItem('firstVisit', true);
      }
    }
  }








}
